<div class="search">
	<input id="{{inputFieldId}}" class="form-control search-input" (keydown.enter)="search($event)" placeholder="{{placeHolder | translate}}" [(ngModel)]="searchValue">
	<i class="ti ti-search small"></i>
</div>
